import { makeRequest } from "../helpers/api.helpers";
import {
  FipeBrandType,
  FipeModelType,
  FipeReferenceType,
} from "../../types/fipe.types";
import { FipeInfoType, IVehicle } from "../../types/vehicle.type";

const API_URL = import.meta.env.VITE_API_URL;

export async function getLastReference() {
  const url = `${API_URL}/fipe/last-reference`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return makeRequest<FipeReferenceType>(url, options);
}

export async function getBrands() {
  const url = `${API_URL}/fipe/brands`;
  const options = {
    method: "GET",
    skipUFParam: true,
    skipUFHeader: true,
  };
  return makeRequest<FipeBrandType[]>(url, options);
}

export async function getModelsByBrand(brandFipeId: string) {
  const url = `${API_URL}/fipe/brands/${brandFipeId}/models`;
  const options = {
    method: "GET",
    skipUFParam: true,
    skipUFHeader: true,
  };
  return makeRequest<FipeModelType[]>(url, options);
}

export async function getYearModels(data) {
  const params = new URLSearchParams(data);

  const url = `${API_URL}/fipe/model-years?${params.toString()}`;
  const options = {
    method: "GET",
  };
  return makeRequest(url, options);
}

export async function bindFipeData(vehicleId: string, data: FipeInfoType) {
  const body = JSON.stringify({
    vehicleId,
    brandFipeId: data.brand.fipeId,
    modelFipeId: data.model.fipeId,
    yearModelFipeId: data.yearModel.fipeId,
  });

  const url = `${API_URL}/vehicle/bind-fipe`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body
  };
  return makeRequest<IVehicle>(url, options);
}
